import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { PokemonCard } from '../types/pokemon';

export function useSetCards(setCode: string | undefined) {
  const [cards, setCards] = useState<PokemonCard[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAllSetCards = async () => {
      if (!setCode) {
        setLoading(false);
        return;
      }
      
      try {
        setLoading(true);
        setError(null);
        
        const { data, error } = await supabase
          .from('cards')
          .select('*')
          .eq('set', setCode);

        if (error) throw error;
        setCards(data || []);
      } catch (err) {
        console.error('Error fetching cards:', err);
        setError(err instanceof Error ? err.message : 'Une erreur est survenue');
        setCards([]); // Reset cards on error
      } finally {
        setLoading(false);
      }
    };

    fetchAllSetCards();
  }, [setCode]);

  return { cards, loading, error };
}